import { fetchWithToken, getWithToken, postWithToken } from "../authentication/AuthProvider";
import config, { apiUrl } from "../config";

const reused_product = apiUrl + "/reused_product";
const routes = {
  label: "Reused Product",
  root: reused_product,
  get_by_product_id: reused_product + "/get_by_product_id",
  update_product_info: reused_product + "/update_product_info",
  update_supplier_info: reused_product + "/update_supplier_info",
  update_scope_and_goals: reused_product + "/update_scope_and_goals",
  reset_product_info: reused_product + "/reset_product_info",
  reset_supplier_info: reused_product + "/reset_supplier_info",
  reset_scope_and_goals: reused_product + "/reset_scope_and_goals",
  get_photo: reused_product + "/get_photo",
  get_spec_document: reused_product + "/get_spec_document",
  get_safety_document: reused_product + "/get_safety_document",
  reset_photo: reused_product + "/reset_photo",
  reset_spec_document: reused_product + "/reset_spec_document",
  reset_safety_document: reused_product + "/reset_safety_document",
};

export const ReusedProduct = {
  label: routes.label,
  getByProductId: (product_id) => getWithToken(routes.get_by_product_id, { product_id }),
  updateProductInfo: (product_info) => fetchWithToken(routes.update_product_info, { ...config.method.POST, body: product_info }),
  updateSupplierInfo: (supplier_info) => postWithToken(routes.update_supplier_info, supplier_info),
  updateScopeAndGoals: (scope_and_goals) => postWithToken(routes.update_scope_and_goals, scope_and_goals),
  resetProductInfo: (id) => postWithToken(routes.reset_product_info, { id }),
  resetSupplierInfo: (id) => postWithToken(routes.reset_supplier_info, { id }),
  resetScopeAndGoals: (id) => postWithToken(routes.reset_scope_and_goals, { id }),
  getPhoto: (id) => getWithToken(routes.get_photo, { id }),
  getSpecDocument: (id) => getWithToken(routes.get_spec_document, { id }),
  getSafetyDocument: (id) => getWithToken(routes.get_safety_document, { id }),
  resetPhoto: (id) => postWithToken(routes.reset_photo, { id }),
  resetSpecDocument: (id) => postWithToken(routes.reset_spec_document, { id }),
  resetSafetyDocument: (id) => postWithToken(routes.reset_safety_document, { id }),
};
